var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChromeIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.898 11.9997C19.898 16.361 16.3612 19.8978 11.9999 19.8978C7.63857 19.8978 4.10181 16.361 4.10181 11.9997C4.10181 7.63833 7.63857 4.10156 11.9999 4.10156C16.3612 4.10156 19.898 7.63833 19.898 11.9997Z",
    fill: "#4CAF50"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9994 4.10156V11.9997L15.1586 13.5793L11.6665 19.8978C11.7917 19.8978 11.8742 19.8978 11.9994 19.8978C16.3643 19.8978 19.8975 16.3645 19.8975 11.9997C19.8975 7.63478 16.3643 4.10156 11.9994 4.10156Z",
    fill: "#FFC107"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.898 11.9997C19.898 16.361 16.3612 19.8978 11.9999 19.8978C7.63857 19.8978 4.10181 16.361 4.10181 11.9997C4.10181 7.63833 7.63857 4.10156 11.9999 4.10156C16.3612 4.10156 19.898 7.63833 19.898 11.9997Z",
    fill: "#4CAF50"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9994 4.10156V11.9997L15.1586 13.5793L11.6665 19.8978C11.7917 19.8978 11.8742 19.8978 11.9994 19.8978C16.3643 19.8978 19.8975 16.3645 19.8975 11.9997C19.8975 7.63478 16.3643 4.10156 11.9994 4.10156Z",
    fill: "#FFC107"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0447 8.44551H11.9996V13.5793L10.8149 13.1844L5.34945 7.75838H5.34155C6.73952 5.55876 9.19977 4.10156 11.9996 4.10156C15.0799 4.10156 17.7455 5.87074 19.0447 8.44551Z",
    fill: "#F44336"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.34863 7.76074L8.84078 13.6298L10.8149 13.1852L5.34863 7.76074Z",
    fill: "#DD2C00"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6665 19.8987L15.1946 13.5569L13.579 12.3955L11.6665 19.8987Z",
    fill: "#558B2F"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0548 8.44629H11.9998L11.3762 10.255L19.0548 8.44629Z",
    fill: "#F9A825"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5541 12.0004C15.5541 13.9627 13.9622 15.5546 11.9999 15.5546C10.0377 15.5546 8.4458 13.9627 8.4458 12.0004C8.4458 10.0382 10.0377 8.44629 11.9999 8.44629C13.9622 8.44629 15.5541 10.0382 15.5541 12.0004Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M14.764 12.0007C14.764 13.5278 13.5268 14.765 11.9997 14.765C10.4726 14.765 9.23535 13.5278 9.23535 12.0007C9.23535 10.4736 10.4726 9.23633 11.9997 9.23633C13.5268 9.23633 14.764 10.4736 14.764 12.0007Z",
    fill: "#2F86C7"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChromeIcon);
export default __webpack_public_path__ + "static/media/chrome-icon.e123b8fa068ea747de110954cfa7479a.svg";
export { ForwardRef as ReactComponent };